import { render } from "./TallyLogReportTab.vue?vue&type=template&id=77c80bd9&scoped=true"
import script from "./TallyLogReportTab.vue?vue&type=script&lang=js"
export * from "./TallyLogReportTab.vue?vue&type=script&lang=js"

import "./TallyLogReportTab.vue?vue&type=style&index=0&id=77c80bd9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c80bd9"]])

export default __exports__